import { ProductEventType } from '../shared/producteventtype.enum';

export type FormStateConfig = {
    disabled?: string[];
    enabled?: string[];
    visible?: string[];
    values?: { [key: string]: string | null };
};

export const PRODUCT_EVENT_FORM_RULES: Record<string, FormStateConfig> = {
    [ProductEventType.MANUFACTURED]: {
        disabled: ['fromStorageType', 'toStorageType', 'partnerId', 'orderDetailReference', 'unitPrice', 'festivalId'],
        enabled: ['productId', 'productReference', 'quantity', 'eventDate', 'comment'],
        visible: ['toStorageType', 'productId', 'productReference', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: 'PRESS' }
    },
    [ProductEventType.ADDED_TO_STORAGE]: {
        disabled: ['fromStorageType', 'partnerId', 'orderDetailReference', 'productReference', 'unitPrice', 'festivalId'],
        enabled: ['toStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'toStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: 'PRESS', toStorageType: null }
    },
    [ProductEventType.SOLD_TO_PARTNER]: {
        disabled: ['toStorageType', 'productReference', 'festivalId'],
        enabled: ['fromStorageType', 'productId', 'partnerId', 'orderDetailReference', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'productId', 'partnerId', 'orderDetailsReference', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: null }
    },
    [ProductEventType.SOLD_VIA_WEBSHOP]: {
        disabled: ['toStorageType', 'partnerId', 'orderDetailReference', 'festivalId', 'productReference'],
        enabled: ['fromStorageType', 'productId', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'productId', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: null }
    },
    [ProductEventType.TEASED]: {
        disabled: ['toStorageType', 'partnerId', 'orderDetailReference', 'festivalId', 'productReference'],
        enabled: ['fromStorageType', 'productId', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'productId', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: null }
    },
    [ProductEventType.SCRAPPED]: {
        disabled: ['toStorageType', 'orderDetailReference', 'productReference', 'unitPrice', 'festivalId', 'partnerId'],
        enabled: ['fromStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'productId', 'partnerId', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: null }
    },
    [ProductEventType.GAVE_AWAY_AS_HONORARY_COPY]: {
        disabled: ['toStorageType', 'partnerId', 'productReference', 'orderDetailReference', 'unitPrice', 'festivalId'],
        enabled: ['fromStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: null }
    },
    [ProductEventType.SOLD_ON_FESTIVAL]: {
        disabled: ['fromStorageType', 'toStorageType', 'partnerId', 'productReference', 'orderDetailReference'],
        enabled: ['festivalId', 'productId', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'festivalId', 'productId', 'quantity', 'unitPrice', 'eventDate', 'comment'],
        values: { fromStorageType: 'FESTIVAL', toStorageType: null }
    },
    [ProductEventType.MOVED_OUT_TO_FESTIVAL]: {
        disabled: ['toStorageType', 'partnerId', 'productReference', 'orderDetailReference'],
        enabled: ['fromStorageType', 'festivalId', 'productId', 'quantity', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'toStorageType', 'festivalId', 'productId', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: 'FESTIVAL' }
    },
    [ProductEventType.RETURNED_FROM_FESTIVAL]: {
        disabled: ['fromStorageType', 'partnerId', 'productReference', 'orderDetailReference'],
        enabled: ['toStorageType', 'festivalId', 'productId', 'quantity', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'toStorageType', 'festivalId', 'productId', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: 'FESTIVAL', toStorageType: null }
    },
    [ProductEventType.DELEGATED_TO_PARTNER]: {
        disabled: ['toStorageType', 'productReference', 'unitPrice', 'festivalId'],
        enabled: ['fromStorageType', 'productId', 'partnerId', 'orderDetailReference', 'quantity', 'eventDate', 'comment'],
        visible: [
            'fromStorageType',
            'toStorageType',
            'productId',
            'partnerId',
            'orderDetailsReference',
            'quantity',
            'eventDate',
            'comment'
        ],
        values: { fromStorageType: null, toStorageType: 'PARTNER_WAREHOUSE' }
    },
    [ProductEventType.RETURNED_FROM_DELEGATION]: {
        disabled: ['fromStorageType', 'productReference', 'unitPrice', 'festivalId'],
        enabled: ['toStorageType', 'productId', 'partnerId', 'orderDetailReference', 'quantity', 'eventDate', 'comment'],
        visible: [
            'fromStorageType',
            'toStorageType',
            'productId',
            'partnerId',
            'orderDetailsReference',
            'quantity',
            'eventDate',
            'comment'
        ],
        values: { fromStorageType: 'PARTNER_WAREHOUSE', toStorageType: null }
    },
    [ProductEventType.SOLD_FROM_DELEGATION]: {
        disabled: ['fromStorageType', 'toStorageType', 'productReference', 'unitPrice', 'festivalId'],
        enabled: ['productId', 'partnerId', 'orderDetailReference', 'quantity', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'productId', 'partnerId', 'orderDetailsReference', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: 'PARTNER_WAREHOUSE', toStorageType: null }
    },
    [ProductEventType.RETURNED_FROM_SCRAP]: {
        disabled: ['fromStorageType', 'partnerId', 'productReference', 'orderDetailReference', 'unitPrice', 'festivalId'],
        enabled: ['toStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        visible: ['toStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: null }
    },
    [ProductEventType.MOVED_BETWEEN_STORAGES]: {
        disabled: ['partnerId', 'orderDetailReference', 'productReference', 'unitPrice', 'festivalId'],
        enabled: ['fromStorageType', 'toStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        visible: ['fromStorageType', 'toStorageType', 'productId', 'quantity', 'eventDate', 'comment'],
        values: { fromStorageType: null, toStorageType: null }
    },
    DEFAULT: {
        enabled: [
            'fromStorageType',
            'toStorageType',
            'productId',
            'partnerId',
            'orderDetailReference',
            'productReference',
            'quantity',
            'unitPrice',
            'eventDate',
            'comment'
        ],
        values: { fromStorageType: null, toStorageType: null }
    }
};
